import React from 'react';


const FormRadio = function (props) {
  const {
    image, className, selectedValue, text, ...rest
  } = props;
  return (
    <label className={className}>
      {image && <img src={image} alt={text} />}
      <input type="radio" checked={rest.value === selectedValue} {...rest} onChange={() => { /* let event bubble */ }} />
      <div className="name">{text}<span className="checkmark" /></div>
    </label>
  );
};

export default FormRadio;



// WEBPACK FOOTER //
// ./src/pages/Helpers/Form/FormRadio.js